module.exports = __webpack_public_path__ + "img/avatar4.227beff0.jpg";